import { gql } from '@apollo/client';

export default gql`
  mutation createTransactionForInvoice($input: CreateTransactionInput!) {
    createTransactionForInvoice(input: $input) {
      id
    }
  }
`;
